import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <section className="wc-container py-24 text-center">
    <p className="wc-eyebrow">404</p>
    <h1 className="mt-2 text-3xl font-bold">This page doesn't exist</h1>
    <p className="mt-3 text-muted">If you followed a signing link, open it again from your portal.</p>
    <Link to="/" className="wc-btn-primary mt-8">Back to the home page</Link>
  </section>
);

export default NotFound;
